import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { hasIn } from 'lodash';
import { Breadcrumb } from '../../../core/interfaces';
import { TranslationService } from '../../../core/services';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.less'],
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  ngUnsubscribe: Subject<any> = new Subject();
  public breadcrumbs: Breadcrumb[];
  paramsList: {}[];

  /**
  /*.filter(event => event instanceof NavigationEnd)
 .distinctUntilChanged()
 .map(event =>  this.buildBreadCrumb(this.activatedRoute.root)); */

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title,
    private translationService: TranslationService
  ) {}

  ngOnInit() {
    let breadcrumb: Breadcrumb = {
      label: 'PAGE.HOMEPAGE.TITLE',
      url: '/',
    };

    this.route.params.pipe(takeUntil(this.ngUnsubscribe)).subscribe((param) => {
      this.paramsList = Object.values(param);
    });

    this.setup(breadcrumb);

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((event) => {
        //set breadcrumbs
        this.setup(breadcrumb);
      });
  }

  setup(breadcrumb) {
    const label = this.route.routeConfig;

    let root: ActivatedRoute = this.route.root;
    this.breadcrumbs = this.getBreadcrumbs(root);
    this.breadcrumbs = [breadcrumb, ...this.breadcrumbs];

    this.translationService
      .stream(this.breadcrumbs[this.breadcrumbs.length - 1].label)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((translatedTitle: string) => {
        this.titleService.setTitle(translatedTitle);
      });
  }

  private getBreadcrumbs(
    route: ActivatedRoute,
    url: string = '',
    breadcrumbs: Breadcrumb[] = []
  ): Breadcrumb[] {
    const ROUTE_DATA_BREADCRUMB: string = 'breadcrumb';

    //get the child routes
    let child: ActivatedRoute[] = route.children;

    //return if there are no more children
    if (!child.length) {
      return breadcrumbs;
    }

    const routeObj = child[0].routeConfig;
    let newPath;
    let currentParam;

    // find any immediate param id's
    child[0].params.pipe(takeUntil(this.ngUnsubscribe)).subscribe((param) => {
      // _.forEach(param, (val) => {
      //   currentParam = val;
      // });
      const params = Object.values(param);
      currentParam = params[params.length - 1];
    });

    if (
      typeof routeObj !== 'undefined' &&
      typeof routeObj.data !== 'undefined'
    ) {
      // create a new path
      newPath = currentParam
        ? `${url}/${currentParam}/${routeObj.path}`
        : `${url}/${routeObj.path}`;

      let breadcrumb: Breadcrumb = {
        label: routeObj.data[ROUTE_DATA_BREADCRUMB],
        url: newPath,
      };

      let prevUrl;
      // pathFix
      if (hasIn(breadcrumbs[breadcrumbs.length - 1], 'url')) {
        prevUrl = breadcrumbs[breadcrumbs.length - 1].url;
        let prevParams;

        if (currentParam && typeof currentParam !== 'undefined') {
          prevParams = currentParam;
          breadcrumbs[breadcrumbs.length - 1].url = `${prevUrl}/${prevParams}`;
          // breadcrumbs.push(breadcrumb);
        } else if (
          typeof this.paramsList[this.paramsList.length - 1] !== 'undefined'
        ) {
          prevParams = this.paramsList[this.paramsList.length - 1];
          breadcrumbs[breadcrumbs.length - 1].url = `${prevUrl}/${prevParams}`;
        }
      }
      breadcrumbs.push(breadcrumb);
    }

    if (child[0].children[0]) {
      this.getBreadcrumbs(child[0].children[0], newPath, breadcrumbs);
    }

    return breadcrumbs;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
